<template>
  <div class="list" style="padding: 0 5px 0 5px;">
    <!-- <div v-if="imgList.length>0  && ispicLink">
      <div
     class="linktext"
      v-for="(item,i) in imgList"  :key="i" v-show="i<4">
      <a :href="item.linkAddress" target="_blank" :alt="item.Tips" v-if="item.IsPicture">
        <img :src="ImgUrl+item.PictureFilename" :alt="item.Ad_Text" style="width:100%" />
      </a>
    </div>
    </div> -->
    <div v-if="textList.length>0">
      <ul>
      <li v-for="(items,index) in textList"
      :key="index">
        <a :href="items.linkAddress" target="_blank" :alt="items.Tips">{{items.LinkName}}</a>
        </li>
    </ul>
    </div>
    
  </div>
</template>
<script>
export default {
data () {
    return {
      imgList: [], 
      textList: [] 
    }
  },
  props:["ispicLink"],
  mounted(){
      this.postFirend()
  },
    methods: {
    postFirend(){
      let params = [{
        Type:2,
        Size: 0
      },{
        Type:1,
        Size: 0
      }]
    // let LinkArr=  
    this.$store.dispatch("_postFirend",params).then(res=>{
       this.textList =res.data.Data.Text
       this.imgList = res.data.Data.Img
    }).catch(err=>{
      console.log(err)
    })
    },
  }
};
</script>
<style scoped>
.list ul{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.list ul li{
  background: none !important;
  width: 18%;
}
</style>